"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var n = require("./lite-DyshwcGq.js"),
    t = require("./index.js");

var i = /*#__PURE__*/function (_n$ServerSafeHTMLElem) {
  _inherits(i, _n$ServerSafeHTMLElem);

  var _super = _createSuper(i);

  function i() {
    var _this;

    _classCallCheck(this, i);

    _this = _super.apply(this, arguments), _this._flows = new Set(), _this._addDescendant = function (e) {
      e.batched = !0, _this._flows.add(e);
    }, _this._removeDescendant = function (e) {
      e.batched = !1, _this._flows.delete(e);
    }, _this._onDescendantConnected = function (e) {
      _this._addDescendant(e.target);
    }, _this._updating = !1, _this._onDescendantUpdate = function () {
      _this._updating || (_this._updating = !0, _this._flows.forEach(function (e) {
        e.created && (e.willUpdate(), queueMicrotask(function () {
          e.connected && e.didUpdate();
        }));
      }), queueMicrotask(function () {
        _this._updating = !1;
      }));
    };
    return _this;
  }

  _createClass(i, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this,
          _this$_mutationObserv;

      this.querySelectorAll("number-flow").forEach(function (e) {
        _this2._addDescendant(e);
      }), this.addEventListener(t.CONNECT_EVENT, this._onDescendantConnected), this.addEventListener(t.UPDATE_EVENT, this._onDescendantUpdate), (_this$_mutationObserv = this._mutationObserver) !== null && _this$_mutationObserv !== void 0 ? _this$_mutationObserv : this._mutationObserver = new MutationObserver(function (e) {
        e.forEach(function (r) {
          r.removedNodes.forEach(function (s) {
            s instanceof t.default && _this2._removeDescendant(s);
          });
        });
      }), this._mutationObserver.observe(this, {
        childList: !0,
        subtree: !0
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var e;
      this.removeEventListener(t.CONNECT_EVENT, this._onDescendantConnected), this.removeEventListener(t.UPDATE_EVENT, this._onDescendantUpdate), (e = this._mutationObserver) == null || e.disconnect();
    }
  }]);

  return i;
}(n.ServerSafeHTMLElement);

n.define("number-flow-group", i);
module.exports = i;